export const FINANCIAL_INVESTMENTS_TABLE_ARIA_LABEL = 'Фінансові інвестиції';
export const FINANCIAL_INVESTMENTS_TABLE_MIN_WIDTH = 970;
export const FINANCIAL_INVESTMENTS_DATE_COLUMN_INDEXES = [4] as const;
export const FINANCIAL_INVESTMENTS_TABLE_HEADERS = [
  'Найменування підприємства / об’єкта інвестування',
  'ЄДРПОУ',
  'Питома вага, %',
  'Сума, тис. од.',
  'Дата початку інвестування',
] as const;
export const FINANCIAL_INVESTMENTS_TABLE_COLUMN_WIDTHS = [
  '42%',
  '14%',
  '14%',
  '16%',
  '14%',
] as const;
